import { BASE_URL } from '../constants/config';
import axios from './app.utils';

export const PLANNING_ENDPOINTS = {
  getAllPlannings: `${BASE_URL}api/planning/`,
  getPlanningExport: `${BASE_URL}api/planning/export-planning`,
};

const token = localStorage.getItem('authorization');

class Plannings {
  async getAllPlannings() {
    const response = await axios.get(PLANNING_ENDPOINTS.getAllPlannings, {
      headers: {
        authorization: token,
      },
    });

    return response;
  }

  async getPlanningExcel() {
    const response = await axios.get(
      `${PLANNING_ENDPOINTS.getPlanningExport}`,
      {
        responseType: 'blob',
        headers: {
          authorization: token,
        },
      }
    );
    const blob = new Blob([response.data], {
      type: 'application/octet-stream',
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    const filename = `PlanningsData_${new Date()}.xlsx`;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    return response;
  }
}

export const PlanningService = new Plannings();
